import { render, staticRenderFns } from "./campaigns.vue?vue&type=template&id=392b84dd&"
import script from "./campaigns.vue?vue&type=script&lang=js&"
export * from "./campaigns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports